import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.open = false
  }

  toggle() {
    this.open = !this.open
    this.panelTarget.classList.toggle("is-open", this.open)
  }

  // Close when clicking a nav link
  close() {
    this.open = false
    this.panelTarget.classList.remove("is-open")
  }
}
